import { render, staticRenderFns } from "./GroupChips.vue?vue&type=template&id=0c6a0190"
import script from "./GroupChips.vue?vue&type=script&lang=ts"
export * from "./GroupChips.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c6a0190')) {
      api.createRecord('0c6a0190', component.options)
    } else {
      api.reload('0c6a0190', component.options)
    }
    module.hot.accept("./GroupChips.vue?vue&type=template&id=0c6a0190", function () {
      api.rerender('0c6a0190', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/companyProjects/GroupChips.vue"
export default component.exports